import { render } from "./AppLayoutDefault.vue?vue&type=template&id=61d4a09f"
const script = {}

import "./AppLayoutDefault.vue?vue&type=style&index=0&id=61d4a09f&lang=scss"

import exportComponent from "/Users/carloslazcanoyoung/PROJECT/MUSS/COMPANY/SOFOFA/IEE/iee-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__